function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BF3030",
  d: "M29.1 6.52c1.22 0 2.2.98 2.2 2.2V30.8a2.2 2.2 0 01-4.4 0V8.71c0-1.21.98-2.2 2.2-2.2zm-8.83 6.62c1.22 0 2.2.99 2.2 2.2V30.8a2.2 2.2 0 11-4.4 0V15.34c0-1.21.98-2.2 2.2-2.2zm-8.83 6.62c1.22 0 2.2.98 2.2 2.2v8.85a2.2 2.2 0 01-2.2 2.19 2.2 2.2 0 01-2.2-2.2v-8.85c0-1.2.98-2.2 2.2-2.2zm-8.83 6.62c1.22 0 2.21.97 2.21 2.17v2.28c0 1.2-.99 2.17-2.2 2.17A2.2 2.2 0 01.4 30.83v-2.28c0-1.2.99-2.17 2.2-2.17z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 4.266,
  height: 22.186,
  x: 35.712,
  y: -0.005,
  fill: "#BF3030",
  rx: 2.133
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BF3030",
  strokeLinecap: "round",
  d: "M35.4 27.55l4.92 5.04m-.05-5.06l-4.85 5.04"
});

function SvgUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 34,
    fill: "none",
    viewBox: "0 0 41 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailable);
export default __webpack_public_path__ + "static/media/unavailable.18e2cf7b.svg";
export { ForwardRef as ReactComponent };